import React from 'react';
export default function Blogs() {
  return <div className="page-content"><h1>Blogs</h1></div>;
}